import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'react-admin';

const AddNewProdApprovalEntryButton = ({ record }) => (
    <Button
        variant="contained"
        component={Link}
        to={`/new-prod-approval-entry/${record.id}`}
        label="Add production approval entry"
        style={{ marginTop: '1em', marginBottom: '1em' }}
    />
);

export default AddNewProdApprovalEntryButton;
